/**
 *  Redirige vers la home si utilisateur pro
 */

import { useMagasinStore } from "@/store/magasin";

export default function ({ store, redirect }) {

  const { $pinia } = useNuxtApp();
  const magasinStore = useMagasinStore($pinia);

  if (!useRuntimeConfig().public.CARTE_DEMAT_PHASE_PILOTE) {
    return;
  }
  if (!useRuntimeConfig().public.CARTE_DEMAT_MAGASINS_PILOTE.includes(magasinStore.id)) {
    return navigateTo("/infos-et-services/aide/contactez-nous/formulaire-demande-carte-malin");
  }
}
